import React from "react";
import { Box } from "theme-ui";

interface TableProps {
  children: React.ReactNode;
}

function Table(props: TableProps) {
  return (
    <Box
      as="table"
      {...props}
      sx={{
        borderCollapse: "collapse",
        borderSpacing: 0,
        width: "100%",
      }}
    />
  );
}

export default Table;
